import { Button, Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

type GenerateMenuProps = {
  openSuitabilityFlow: () => void;
  openAgendaFlow: () => void;
  openDataExportFlow: () => void;
  openMeetingNote: () => void;
  buttonText?: string;
};

export default function GenerateMenu({
  openSuitabilityFlow,
  openAgendaFlow,
  openDataExportFlow,
  openMeetingNote,
  buttonText = 'Generate',
}: GenerateMenuProps) {
  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <Button
          variant="primary"
          color="brand.6"
          rightSection={<IconChevronDown size={16} />}
          size="md"
        >
          {buttonText}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={openSuitabilityFlow}>Suitability report</Menu.Item>
        <Menu.Item onClick={openAgendaFlow}>Meeting agenda</Menu.Item>
        <Menu.Item onClick={openMeetingNote}>Meeting note</Menu.Item>
        <Menu.Item onClick={openDataExportFlow}>Data export</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
